<template>
	<div class="action-button-wrapper end">
      <b-button size="sm" variant="link" class="site-action-btn danger" @click="emitAction('removeSite')">
          <span class="icon-cont">
              <delete-icon class="icon-default delete-icon"></delete-icon>
          </span>
          <span>remove site</span>
      </b-button>
  </div>
</template>

<script>
import DeleteIcon from '../../assets/delete.svg';
export default {
  name: "viewsite",
  props: ["site"],
  components:{
  	DeleteIcon
  },
  data() {
    return {
      serverURL: window.serverURL,
    };
  },
  methods:{
    emitAction(action) {
      this.$emit('action', { action: action, site: this.site });
    },
  }
};
</script>